import { pipe } from 'ramda';

import {
  buildCmsUrl,
  CMSApiBase,
  CMSGroupParams,
  CMSImageBase,
  getResponseCMS,
} from './base';
import { request } from '@/api/base';
import { getResponseCamelization } from '@/helpers/api';
import { isCMSV3 } from '@/helpers/conf';
import { useCommonStore } from '@/store';

export interface ReferralHowToParticipateCard {
  title: string;
  description: string;
  id: number;
  cardImage: CMSImageBase;
}

export interface ReferralDataItem {
  question: string;
  answer: string;
}

export interface ReferralHowToCard {
  title: string;
  description: string;
}

export interface ReferralHowToParticipate extends CMSGroupParams {
  cards: ReferralHowToParticipateCard[];
  content: ReferralHowToCard[];
}

export interface RefferalProgramApi extends CMSApiBase {
  title: string;
  description: string;
  bonusTitle: string;
  bonusSubtitle: string;
  howToTitle: string;
  enable: boolean;
  topBg: CMSImageBase;
  leftImg: CMSImageBase;
  rightImg: CMSImageBase;
  lupImg: CMSImageBase;
  onePlusImg: CMSImageBase;
  mobImg: CMSImageBase;
  referralBonus: string;
  howToParticipate: ReferralHowToParticipate;
  questions: ReferralDataItem[];
  cards: ReferralHowToParticipateCard[];
}

export const referralProgramV3 = (lang: string) =>
  request<RefferalProgramApi>({
    url: buildCmsUrl({ path: 'referral-program', lang }),
  });

export const referralProgramV4 = (lang: string) =>
  request<RefferalProgramApi>({
    url: buildCmsUrl({
      path: 'referral-program',
      lang,
      additionalParams: { populate: 'deep' },
    }),
    transformResponse: pipe(
      getResponseCamelization,
      getResponseCMS<RefferalProgramApi>
    ),
  });

export const referralProgram = isCMSV3 ? referralProgramV3 : referralProgramV4;

export const fetchReferralProgram = (lang: string) => {
  useCommonStore.setState({ pendingReferralProgramData: true });

  return referralProgram(lang)
    .then(({ data }) => {
      useCommonStore.setState({ referralProgramData: data });
    })
    .finally(() => {
      useCommonStore.setState({ pendingReferralProgramData: false });
    });
};
